import { formatMoney } from './format'

export function MoneyValue({
  value,
  currency = 'USD',
  className = '',
}: {
  value: number
  currency?: string
  className?: string
}) {
  const full = value?.toLocaleString(undefined, { maximumFractionDigits: 0 })
  return (
    <span className={className} title={full ? `${currency} ${full}` : undefined}>
      {formatMoney(value, currency)}
    </span>
  )
}
